import React, { Component } from 'react';
import UserContainer from 'src/components/parts/UserContainer';
import {Helmet} from 'react-helmet';
import { connect } from "react-redux";
import { setText, setUsers } from "src/cms.js";

//	This maps the data store to local variables.
const mapStateToProps = state  => {
	return {
	  meta_title: state.meta_title,
	  meta_description: state.meta_description,
	  content: state.content,
	  firstLoad: state.firstLoad,
	};
};

class Search extends Component {

	constructor(props) {

		super(props);

		//	For the first load we will render it on the server side. However, user could still click over from Home or other page.
		if( process.env.NODE_ENV === 'development' || this.props.firstLoad === false ) {

			this.props.dispatch({type: 'GET_ALL_USERS_RESET'});	// after getting initial users will allow for when scroll happens will get all users again
			
			props.dispatch({type: 'RESET_SHOW_USERS'}); // Set number of users to show back to default.

			setUsers(props);

			setText(props);

		}

	}

	//
	//	Do not neet to do an update check on this search component
	//	since each search will reload the page / prop.
	//	
	/*
	componentDidUpdate(prevProps, prevState) {

		//	Make sure there was a change in pages
		if( process.env.NODE_ENV === 'development' || this.props.location.pathname !== prevProps.location.pathname) {
	
			this.props.dispatch({type: 'GET_ALL_USERS_RESET'});	// after getting initial users will allow for when scroll happens will get all users again

			if( this.props.firstLoad === false ) {

				this.props.dispatch({type: 'RESET_SHOW_USERS'});	// Set number of users to show back to default.

				setUsers(prevProps);

				setText(prevProps);

			}

		}

	}
*/
	render() {
	  return (
		<div>
			<UserContainer showOrderBox={true} />
			<div>
				{this.props.content}
			</div>
			<Helmet>
				<title>{this.props.meta_title}</title>
				<meta name="description" content="{this.props.meta_description}" />
			</Helmet>
        </div>
	  );
	}
}


//	Export with redux connections.
export default connect(mapStateToProps)(Search);


// WEBPACK FOOTER //
// ./src/components/pages/Search.js